const JsSubNavMenu = {
	init () {

		/*
		* Sub menu hover - options
		*/

		if ( $('.hoverlist .nav-arrow').length ) {

			/**
			  * Hides the subnav boxes and remove active hover arrow
			  * @return {void}
			*/
			function hideBoxes () {
				$boxes.delay(1000).hide();
				$('.nav-arrow').removeClass('show-arrow');
			}
		
			$productLinks = $('.hoverlist .nav-arrow').mouseover(function() {
				hideBoxes(); // hide any others that are visible first
				$(this).addClass('show-arrow');
				$boxes.hide().filter('#sub-' + this.id).show();
				// $arrow.show();
			});

			$(".c-header").mouseleave(hideBoxes);
			$(".linked").mouseover(hideBoxes);
		}
	}
};

export default JsSubNavMenu;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/sub-nav-menu.js